import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { ToolbarComponent } from '../toolbar/toolbar.component';
import { ScrollPanelModule } from 'primeng/scrollpanel';
import { CommonModule, DatePipe, LowerCasePipe } from '@angular/common';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { ButtonModule } from 'primeng/button';
import { TooltipModule } from 'primeng/tooltip';
import { AvatarComponent } from '../avatar/avatar.component';
import { Toolbar } from '@modules/search/interfaces/interface';
import { ConfirmPopupModule } from 'primeng/confirmpopup';
import { ConfirmationService } from 'primeng/api';
import { EmailInfoComponent } from "../../../../shared/components/email-info/email-info.component";
import { EmailUtilsService } from '@shared/services/utils/email-utils.service';

@Component({
  selector: 'app-email-head',
  standalone: true,
  imports: [
    ToolbarComponent,
    ScrollPanelModule,
    DatePipe,
    OverlayPanelModule,
    ButtonModule,
    TooltipModule,
    LowerCasePipe,
    AvatarComponent,
    CommonModule,
    ConfirmPopupModule,
    EmailInfoComponent,
],
  providers: [ConfirmationService],
  templateUrl: './email-head.component.html',
  styleUrl: './email-head.component.scss',
})
export class EmailHeadComponent implements OnChanges {

  @Input() headerData: any;
  @Input() isShowHeader: boolean = true;
  @Input() toolbar : Toolbar[] = [];

  name : string = "";
  from : string = "";
  to : string[] = [];
  cc : string[] = [];
  subject : string = "";
  date : string = "";
  isToShow : boolean = false;
  isCCShow : boolean = false;

  constructor(
    private confirmationService : ConfirmationService,
    private readonly _emailUtils: EmailUtilsService
  ) {}

  ngOnChanges(changes: SimpleChanges) {
    let tempName = Array.isArray(this.headerData.metaData.from_name) ? this.headerData.metaData.from_name[0] : this.headerData.metaData.from[0].split('<')[0].trim().replace(/"/g, '');
    if(this.checkValidName(tempName)){
      this.name = tempName;
    }else{
      if(this.checkValidEmail(tempName)){
        this.name = this.getNameFromEmailExcludingNumbers(tempName);
      }else{
        tempName = Array.isArray(this.headerData.metaData.from) ? this.headerData.metaData.from[0].split('<')[0].trim().replace(/"/g, '') : this.headerData.metaData.from;
        this.name = this.getNameFromEmailExcludingNumbers(tempName);
      }
    }

    // this.name = Array.isArray(this.headerData.metaData.from_name) ? this.headerData.metaData.from_name[0] : this.headerData.metaData.from_name;
    this.from = this._emailUtils.getEmailIds(this.headerData.metaData.from)[0] || this.headerData.metaData.from.toString();
    this.to = this._emailUtils.getEmailIds(this.headerData.metaData.to);
    this.cc = this._emailUtils.getEmailIds(this.headerData.metaData.cc);
    this.subject = this.headerData.metaData.subject;
    this.date = this.headerData.metaData.date;
  }


  getNameFromEmailExcludingNumbers(email: string): string {
    if (!email || email.indexOf('@') === -1) {
      return email;
    }
    const namePart = email.split('@')[0];
    return namePart.replace(/[0-9]/g, '');
  }

  checkValidName(name: string): boolean {
    if (name.length === 0) {
      return false;
    }
    return /^[a-zA-Z\s]*$/.test(name);
  }

  checkValidEmail(email: string): boolean {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  }

  openEmailInfo(element: any) {
    this.confirmationService.confirm({
      target: element.el.nativeElement as EventTarget ,
      key: 'emailInfoPopup'
    });
  }
}
